import { NavLink } from 'react-router-dom'
import { paths } from '@/routes/paths'

const items = [
  { to: paths.home, label: 'Início', icon: '⌂', end: true },
  { to: paths.reports, label: 'Relatórios', icon: '▤' },
  { to: paths.clients, label: 'Clientes', icon: '◇' },
  { to: paths.machines, label: 'Máquinas', icon: '▣' },
  { to: paths.settings, label: 'Ajustes', icon: '⚙' },
]

export function BottomNavigation() {
  return (
    <nav className="bottom-navigation" aria-label="Navegação principal">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `bottom-navigation__item${isActive ? ' bottom-navigation__item--active' : ''}`
          }
        >
          <span className="bottom-navigation__marker" aria-hidden="true" />
          <span className="bottom-navigation__icon" aria-hidden="true">
            {item.icon}
          </span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
